import { InputSearch } from "@/base/components/index";
import { useFieldSearchStyles } from "./field-search.styles";
import { FieldSearchProps } from "../types/index";
import { useLocalization } from "@/app/hook/use-localization";
import { cx } from "antd-style";

export const FieldSearch = ({
  className,
  placeholder,
  ...inputSearchProps
}: FieldSearchProps) => {
  const { styles } = useFieldSearchStyles();
  const { getText } = useLocalization();

  return (
    <InputSearch
      className={cx(styles.root, className)}
      placeholder={
        placeholder || getText("components.field.search.placeholder.default")
      }
      {...inputSearchProps}
    />
  );
};
